'use strict';

window.RC = window.RC || {};

window.RC.ResourceFilter = (function($) {
  function init() {
    document.querySelectorAll('[data-resource-filter-type]').forEach(node => {
      node.addEventListener('change', e => updateFilterValue(node));
      updateFilterValue(node);
    });
  }
  
  function updateFilterValue(node) {
    const containerNode = node.closest('.container');
    const filterType = node.dataset.resourceFilterType;
    const filterValue = node.value;
    const attrName = `data-${ filterType }`;

    containerNode.querySelectorAll(`[${ attrName }]`).forEach(filteredNode => {
      const shown = !filterValue || (filteredNode.getAttribute(attrName) === filterValue);
      filteredNode.style.display = shown ? null : 'none';
    });
  }
  
  return { init };
})();